export default {
  container: {
    border: '1px solid grey'
  },
  item: {
    borderBottom: '1px solid lightgrey',
    paddingBottom: '4px'
  },
  containerAddCustom: {
    display: 'flex',
    justifyContent: 'center',
    width: '90%',
    background: '#fff',
    position: 'relative'
  },
  line: {
    height: '1px',
    content: '',
    width: '90%',
    position: 'absolute',
    backgroundColor: '#000',
    top: '50%',
    transform: 'translateY(-50%)'
  },
  text: {
    background: '#fff',
    position: 'relative',
    padding: '0 30px'
  }
};